import classNames from "classnames";
import { MarketplaceActivity, MarketplaceActivityStatistics, MatchedActivity } from "PFTypes";
import React, { forwardRef } from "react";

import { RoleCardDetails } from "./parts/role_card_details";
import { RoleCardFooter } from "./parts/role_card_footer";
import { RoleCardHeader } from "./parts/role_card_header";
import css from "./role_card.module.scss";

export type RoleCardProps = {
  role: MarketplaceActivity | MatchedActivity;
  counters?: Partial<MarketplaceActivityStatistics>;
  isSelected: boolean;
  onClick: VoidFunction;
};

export const RoleCard = forwardRef<HTMLDivElement, RoleCardProps>(
  ({ role, isSelected, counters, onClick }, ref) => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={classNames(css.mainContainer, { [css.selected]: isSelected })}
      onClick={onClick}
      ref={ref}
    >
      <RoleCardHeader role={role} />
      <RoleCardDetails role={role} />
      <RoleCardFooter role={role} counters={counters} />
    </div>
  )
);

RoleCard.displayName = "RoleCard";
